export class EditContentUnit {
    constructor(shape, text) {
        this.shape = shape;
        this.nextText = text;
        this.prevText = shape.content();
        this.diagram = shape.diagram;
        this.title = `Edit ${shape.name} Content`;
    }
    undo() {
        this.shape.content({ text: this.prevText });
    }
    redo() {
        this.shape.content({ text: this.nextText });
    }
}
